import BaseServiceCrud from './BaseServiceCrud';

export default class AvatarService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'avatar';
    }

    getCriteria(criteria) {
        return this.objToQueryString({
            locale: criteria?.locale,
            type: criteria?.type?.enumValue,
            first_result: criteria.firstResult,
            max_results: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
        });
    }

    addDefaultUserAvatar(element) {
        return this.fetch(`${this.domain}/${this.path}/user/default`, {
            method: 'POST',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    addDefaultGroupAvatar(element) {
        return this.fetch(`${this.domain}/${this.path}/group/default`, {
            method: 'POST',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    removeAvatar(id) {
        return this.fetch(`${this.domain}/${this.path}/${id}`, {
            method: 'DELETE',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
